import {filterArrayUndefined, undefinedIfThrowSync} from '@coolcolduk/util';
import {DocumentData, QueryDocumentSnapshot} from 'firebase/firestore';

/**
 * Map a query snapshot to an array of objects
 * - remove ones that does not pass the mapper
 * @param docs
 * @param mapper if error, it should throw. this will be caught in this function and removed from the array
 * @returns
 */
export default function mapFirestoreDocs<AppModelType = DocumentData, DbModelType extends DocumentData = DocumentData>(
  docs: QueryDocumentSnapshot<AppModelType, DbModelType>[],
  mapper: (doc: QueryDocumentSnapshot<AppModelType, DbModelType>) => AppModelType | undefined,
): AppModelType[] {
  return filterArrayUndefined(docs.map((doc) => undefinedIfThrowSync(() => mapper(doc))));
}
